export const TRIGGER_FLASHING_EFFECT = 'TRIGGER_FLASHING_EFFECT'
export function triggerFlashingEffect(deviceId) {
    return {
        type: TRIGGER_FLASHING_EFFECT,
        deviceId
    }
}

export const RESET_FLASHING_EFFECT = 'RESET_FLASHING_EFFECT'
export function resetFlashingEffect() {
    return {
        type: RESET_FLASHING_EFFECT
    }
}

export const START_LOCATIONS_SIDEBAR_LOADING = 'START_LOCATIONS_SIDEBAR_LOADING'
export function startLocationsSidebarLoading() {
    return {
        type: START_LOCATIONS_SIDEBAR_LOADING
    }
}

export const STOP_LOCATIONS_SIDEBAR_LOADING = 'STOP_LOCATIONS_SIDEBAR_LOADING'
export function stopLocationsSidebarLoading() {
    return {
        type: STOP_LOCATIONS_SIDEBAR_LOADING
    }
}

export const LOCATIONS_REQUEST = 'LOCATIONS_REQUEST'
export function locationsRequest(params) {
    return {
        type: LOCATIONS_REQUEST,
        params
    }
}

export const LOCATIONS_REQUEST_SUCCESS = 'LOCATIONS_REQUEST_SUCCESS'
export function locationsRequestSuccess(locations) {
    return {
        type: LOCATIONS_REQUEST_SUCCESS,
        locations
    }
}

export const LOCATIONS_REQUEST_ERROR = 'LOCATIONS_REQUEST_ERROR'
export function locationsRequestError() {
    return {
        type: LOCATIONS_REQUEST_ERROR
    }
}

export const SET_LOCATIONS = 'SET_LOCATIONS'
export function setLocations(locations) {
    return {
        type: SET_LOCATIONS,
        locations
    }
}

export const SET_PICKER_LOCATIONS_LIST = 'SET_PICKER_LOCATIONS_LIST'
export function setPickerLocationsList(locations) {
    return {
        type: SET_PICKER_LOCATIONS_LIST,
        locations
    }
}

export const LOCATION_REQUEST = 'LOCATION_REQUEST'
export function locationRequest(locationId) {
    return {
        type: LOCATION_REQUEST,
        locationId
    }
}

export const LOCATION_REQUEST_SUCCESS = 'LOCATION_REQUEST_SUCCESS'
export function locationRequestSuccess(location) {
    return {
        type: LOCATION_REQUEST_SUCCESS,
        location
    }
}

export const LOCATION_REQUEST_ERROR = 'LOCATION_REQUEST_ERROR'
export function locationRequestError() {
    return {
        type: LOCATION_REQUEST_ERROR
    }
}

export const LOCATION_UPDATE_REQUEST = 'LOCATION_UPDATE_REQUEST'
export function locationUpdateRequest(locationId, body) {
    return {
        type: LOCATION_UPDATE_REQUEST,
        locationId,
        body
    }
}

export const LOCATION_UPDATE_SUCCESS = 'LOCATION_UPDATE_SUCCESS'
export function locationUpdateSuccess() {
    return {
        type: LOCATION_UPDATE_SUCCESS
    }
}

export const LOCATION_UPDATE_ERROR = 'LOCATION_UPDATE_ERROR'
export function locationUpdateError() {
    return {
        type: LOCATION_UPDATE_ERROR
    }
}

export const LOCATION_CREATE_REQUEST = 'LOCATION_CREATE_REQUEST'
export function locationCreateRequest(body, history) {
    return {
        type: LOCATION_CREATE_REQUEST,
        body,
        history
    }
}

export const LOCATION_CREATE_SUCCESS = 'LOCATION_CREATE_SUCCESS'
export function locationCreateSuccess(newLocationId) {
    return {
        type: LOCATION_CREATE_SUCCESS,
        newLocationId
    }
}

export const LOCATION_CREATE_ERROR = 'LOCATION_CREATE_ERROR'
export function locationCreateError() {
    return {
        type: LOCATION_CREATE_ERROR
    }
}

export const LOCATIONS_DELETE_REQUEST = 'LOCATIONS_DELETE_REQUEST'
export function locationsDeleteRequest(body) {
    return {
        type: LOCATIONS_DELETE_REQUEST,
        body
    }
}

export const LOCATIONS_DELETE_SUCCESS = 'LOCATIONS_DELETE_SUCCESS'
export function locationsDeleteSuccess() {
    return {
        type: LOCATIONS_DELETE_SUCCESS
    }
}

export const LOCATIONS_DELETE_ERROR = 'LOCATIONS_DELETE_ERROR'
export function locationsDeleteError() {
    return {
        type: LOCATIONS_DELETE_ERROR
    }
}

export const SHARED_USERS_REQUEST = 'SHARED_USERS_REQUEST'
export function sharedUsersRequest() {
    return {
        type: SHARED_USERS_REQUEST
    }
}

export const SHARED_USERS_REQUEST_SUCCESS = 'SHARED_USERS_REQUEST_SUCCESS'
export function sharedUsersRequestSuccess(sharedUsers) {
    return {
        type: SHARED_USERS_REQUEST_SUCCESS,
        sharedUsers
    }
}

export const SHARED_USERS_REQUEST_ERROR = 'SHARED_USERS_REQUEST_ERROR'
export function sharedUsersRequestError() {
    return {
        type: SHARED_USERS_REQUEST_ERROR
    }
}

export const SHARE_LOCATIONS_REQUEST = 'SHARE_LOCATIONS_REQUEST'
export function shareLocationsRequest(locations) {
    return {
        type: SHARE_LOCATIONS_REQUEST,
        locations
    }
}

export const SHARE_LOCATIONS_SUCCESS = 'SHARE_LOCATIONS_SUCCESS'
export function shareLocationsSuccess() {
    return {
        type: SHARE_LOCATIONS_SUCCESS
    }
}

export const SHARE_LOCATIONS_ERROR = 'SHARE_LOCATIONS_ERROR'
export function shareLocationsError() {
    return {
        type: SHARE_LOCATIONS_ERROR
    }
}

export const LOCATION_DEVICES_REQUEST = 'LOCATION_DEVICES_REQUEST'
export function locationDevicesRequest(
    locationId,
    isDevicesToMoveMode,
    filters
) {
    return {
        type: LOCATION_DEVICES_REQUEST,
        locationId,
        isDevicesToMoveMode,
        filters
    }
}

export const LOCATION_DEVICES_SUCCESS = 'LOCATION_DEVICES_SUCCESS'
export function locationDevicesSuccess(locationDevices) {
    return {
        type: LOCATION_DEVICES_SUCCESS,
        locationDevices
    }
}

export const LOCATION_DEVICES_ERROR = 'LOCATION_DEVICES_ERROR'
export function locationDevicesError() {
    return {
        type: LOCATION_DEVICES_ERROR
    }
}

export const FETCH_MORE_LOCATION_DEVICES = 'FETCH_MORE_LOCATION_DEVICES'
export function fetchMoreLocationDevices(
    locationId,
    isDevicesToMoveMode,
    filters
) {
    return {
        type: FETCH_MORE_LOCATION_DEVICES,
        locationId,
        isDevicesToMoveMode,
        filters
    }
}

export const FETCH_MORE_LOCATION_DEVICES_SUCCESS =
    'FETCH_MORE_LOCATION_DEVICES_SUCCESS'
export function fetchMoreLocationDevicesSuccess(locationDevices) {
    return {
        type: FETCH_MORE_LOCATION_DEVICES_SUCCESS,
        locationDevices
    }
}

export const LOCATION_NETWORK_DEVICES_REQUEST =
    'LOCATION_NETWORK_DEVICES_REQUEST'
export function locationNetworkDevicesRequest(
    locationId,
    isDevicesToMoveMode,
    filters
) {
    return {
        type: LOCATION_NETWORK_DEVICES_REQUEST,
        locationId,
        isDevicesToMoveMode,
        filters
    }
}

export const LOCATION_NETWORK_DEVICES_SUCCESS =
    'LOCATION_NETWORK_DEVICES_SUCCESS'
export function locationNetworkDevicesSuccess(locationNetworkDevices) {
    return {
        type: LOCATION_NETWORK_DEVICES_SUCCESS,
        locationNetworkDevices
    }
}

export const LOCATION_NETWORK_DEVICES_ERROR = 'LOCATION_NETWORK_DEVICES_ERROR'
export function locationNetworkDevicesError() {
    return {
        type: LOCATION_NETWORK_DEVICES_ERROR
    }
}

export const LOCATION_REPORTS_REQUEST = 'LOCATION_REPORTS_REQUEST'
export function locationReportsRequest(locationId, filters) {
    return {
        type: LOCATION_REPORTS_REQUEST,
        locationId,
        filters
    }
}

export const LOCATION_MORE_REPORTS_REQUEST = 'LOCATION_MORE_REPORTS_REQUEST'
export function locationMoreReportsRequest(locationId, filters) {
    return {
        type: LOCATION_MORE_REPORTS_REQUEST,
        locationId,
        filters
    }
}

export const LOCATION_REPORTS_SUCCESS = 'LOCATION_REPORTS_SUCCESS'
export function locationReportsSuccess(locationReports) {
    return {
        type: LOCATION_REPORTS_SUCCESS,
        locationReports
    }
}

export const LOCATION_MORE_REPORTS_SUCCESS = 'LOCATION_MORE_REPORTS_SUCCESS'
export function locationMoreReportsSuccess(locationReports) {
    return {
        type: LOCATION_MORE_REPORTS_SUCCESS,
        locationReports
    }
}

export const LOCATION_REPORTS_ERROR = 'LOCATION_DEVICES_ERROR'
export function locationReportsError() {
    return {
        type: LOCATION_REPORTS_ERROR
    }
}

export const LOCATION_STATISTICS_REPORTS_REQUEST =
    'LOCATION_STATISTICS_REPORTS_REQUEST'
export function locationStatisticsReportsRequest(locationId) {
    return {
        type: LOCATION_STATISTICS_REPORTS_REQUEST,
        locationId
    }
}

export const LOCATION_STATISTICS_REPORTS_SUCCESS =
    'LOCATION_STATISTICS_REPORTS_SUCCESS'
export function locationStatisticsReportsSuccess(locationStatisticsReports) {
    return {
        type: LOCATION_STATISTICS_REPORTS_SUCCESS,
        locationStatisticsReports
    }
}

export const LOCATION_STATISTICS_REPORTS_ERROR =
    'LOCATION_STATISTICS_REPORTS_ERROR'
export function locationStatisticsReportsError() {
    return {
        type: LOCATION_STATISTICS_REPORTS_ERROR
    }
}

export const LOCATION_ASSIGNED_USERS_REQUEST = 'LOCATION_ASSIGNED_USERS_REQUEST'
export function locationAssignedUsersRequest(locationId, params) {
    return {
        type: LOCATION_ASSIGNED_USERS_REQUEST,
        locationId,
        params
    }
}

export const LOCATION_ASSIGNED_USERS_SUCCESS = 'LOCATION_ASSIGNED_USERS_SUCCESS'
export function locationAssignedUsersSuccess(sharedUsersWithEntity) {
    return {
        type: LOCATION_ASSIGNED_USERS_SUCCESS,
        sharedUsersWithEntity
    }
}

export const LOCATION_ASSIGNED_USERS_ERROR = 'LOCATION_ASSIGNED_USERS_ERROR'
export function locationAssignedUsersError() {
    return {
        type: LOCATION_ASSIGNED_USERS_ERROR
    }
}

export const AVAILABLE_DEVICES_REQUEST = 'AVAILABLE_DEVICES_REQUEST'
export function availableDevicesRequest(locationId, customerId, params) {
    return {
        type: AVAILABLE_DEVICES_REQUEST,
        locationId,
        customerId,
        params
    }
}

export const AVAILABLE_DEVICES_SUCCESS = 'AVAILABLE_DEVICES_SUCCESS'
export function availableDevicesSuccess(availableDevices) {
    return {
        type: AVAILABLE_DEVICES_SUCCESS,
        availableDevices
    }
}

export const AVAILABLE_DEVICES_ERROR = 'AVAILABLE_DEVICES_ERROR'
export function availableDevicesError() {
    return {
        type: AVAILABLE_DEVICES_ERROR
    }
}

export const AVAILABLE_NETWORK_DEVICES_REQUEST =
    'AVAILABLE_NETWORK_DEVICES_REQUEST'
export function availableNetworkDevicesRequest(locationId, customerId, params) {
    return {
        type: AVAILABLE_NETWORK_DEVICES_REQUEST,
        locationId,
        customerId,
        params
    }
}

export const AVAILABLE_NETWORK_DEVICES_SUCCESS =
    'AVAILABLE_NETWORK_DEVICES_SUCCESS'
export function availableNetworkDevicesSuccess(availableNetworkDevices) {
    return {
        type: AVAILABLE_NETWORK_DEVICES_SUCCESS,
        availableNetworkDevices
    }
}

export const AVAILABLE_NETWORK_DEVICES_ERROR = 'AVAILABLE_NETWORK_DEVICES_ERROR'
export function availableNetworkDevicesError() {
    return {
        type: AVAILABLE_NETWORK_DEVICES_ERROR
    }
}

export const MOVE_TO_LOCATION_DEVICES = 'MOVE_TO_LOCATION_DEVICES'
export function moveToLocationDevices(deviceId) {
    return {
        type: MOVE_TO_LOCATION_DEVICES,
        deviceId
    }
}

export const MOVE_FROM_LOCATION_DEVICES = 'MOVE_FROM_LOCATION_DEVICES'
export function moveFromLocationDevices(deviceId) {
    return {
        type: MOVE_FROM_LOCATION_DEVICES,
        deviceId
    }
}

export const MOVE_TO_LOCATION_NETWORK_DEVICES =
    'MOVE_TO_LOCATION_NETWORK_DEVICES'
export function moveToLocationNetworkDevices(deviceId) {
    return {
        type: MOVE_TO_LOCATION_NETWORK_DEVICES,
        deviceId
    }
}

export const MOVE_FROM_LOCATION_NETWORK_DEVICES =
    'MOVE_FROM_LOCATION_NETWORK_DEVICES'
export function moveFromLocationNetworkDevices(deviceId) {
    return {
        type: MOVE_FROM_LOCATION_NETWORK_DEVICES,
        deviceId
    }
}

export const MOVE_DEVICES_REQUEST = 'MOVE_DEVICES_REQUEST'
export function moveDevicesRequest(devicesToMove, refetchData) {
    return {
        type: MOVE_DEVICES_REQUEST,
        devicesToMove,
        refetchData
    }
}

export const MOVE_DEVICES_SUCCESS = 'MOVE_DEVICES_SUCCESS'
export function moveDevicesSuccess() {
    return {
        type: MOVE_DEVICES_SUCCESS
    }
}

export const MOVE_DEVICES_ERROR = 'MOVE_DEVICES_ERROR'
export function moveDevicesError() {
    return {
        type: MOVE_DEVICES_ERROR
    }
}

export const MOVE_NETWORK_DEVICES_REQUEST = 'MOVE_NETWORK_DEVICES_REQUEST'
export function moveNetworkDevicesRequest(devicesToMove, refetchData) {
    return {
        type: MOVE_NETWORK_DEVICES_REQUEST,
        devicesToMove,
        refetchData
    }
}

export const MOVE_NETWORK_DEVICES_SUCCESS = 'MOVE_NETWORK_DEVICES_SUCCESS'
export function moveNetworkDevicesSuccess() {
    return {
        type: MOVE_NETWORK_DEVICES_SUCCESS
    }
}

export const MOVE_NETWORK_DEVICES_ERROR = 'MOVE_NETWORK_DEVICES_ERROR'
export function moveNetworkDevicesError() {
    return {
        type: MOVE_NETWORK_DEVICES_ERROR
    }
}

export const CREATE_FLOOR_PLAN_REQUEST = 'CREATE_FLOOR_PLAN_REQUEST'
export function createFloorPlanRequest(body) {
    return {
        type: CREATE_FLOOR_PLAN_REQUEST,
        body
    }
}

export const CREATE_FLOOR_PLAN_SUCCESS = 'CREATE_FLOOR_PLAN_SUCCESS'
export function createFloorPlanSuccess() {
    return {
        type: CREATE_FLOOR_PLAN_SUCCESS
    }
}

export const CREATE_FLOOR_PLAN_ERROR = 'CREATE_FLOOR_PLAN_ERROR'
export function createFloorPlanError() {
    return {
        type: CREATE_FLOOR_PLAN_ERROR
    }
}

export const FLOOR_PLAN_REQUEST = 'FLOOR_PLAN_REQUEST'
export function floorPlanRequest(locationId) {
    return {
        type: FLOOR_PLAN_REQUEST,
        locationId
    }
}

export const FLOOR_PLAN_SUCCESS = 'FLOOR_PLAN_SUCCESS'
export function floorPlanSuccess(floorPlan) {
    return {
        type: FLOOR_PLAN_SUCCESS,
        floorPlan
    }
}

export const FLOOR_PLAN_ERROR = 'FLOOR_PLAN_ERROR'
export function floorPlanError() {
    return {
        type: FLOOR_PLAN_ERROR
    }
}

export const DELETE_FLOOR_PLAN_REQUEST = 'DELETE_FLOOR_PLAN_REQUEST'
export function deleteFloorPlanRequest(id, locationId) {
    return {
        type: DELETE_FLOOR_PLAN_REQUEST,
        id,
        locationId
    }
}

export const DELETE_FLOOR_PLAN_SUCCESS = 'DELETE_FLOOR_PLAN_SUCCESS'
export function deleteFloorPlanSuccess() {
    return {
        type: DELETE_FLOOR_PLAN_SUCCESS
    }
}

export const DELETE_FLOOR_PLAN_ERROR = 'DELETE_FLOOR_PLAN_ERROR'
export function deleteFloorPlanError() {
    return {
        type: DELETE_FLOOR_PLAN_ERROR
    }
}

export const SET_IS_ADD_DEVICES_TO_FLOOR_PLAN_MODE =
    'SET_IS_ADD_DEVICES_TO_FLOOR_PLAN_MODE'
export function setIsAddDevicesToFloorPlanMode(isAddDevicesToFloorPlanMode) {
    return {
        type: SET_IS_ADD_DEVICES_TO_FLOOR_PLAN_MODE,
        isAddDevicesToFloorPlanMode
    }
}

export const AVAILABLE_DEVICES_TO_FLOOR_PLANS_REQUEST =
    'AVAILABLE_DEVICES_TO_FLOOR_PLANS_REQUEST'
export function availableDevicesToFloorPlansRequest(
    locationId,
    customerId,
    params
) {
    return {
        type: AVAILABLE_DEVICES_TO_FLOOR_PLANS_REQUEST,
        locationId,
        customerId,
        params
    }
}

export const AVAILABLE_DEVICES_TO_FLOOR_PLANS_SUCCESS =
    'AVAILABLE_DEVICES_TO_FLOOR_PLANS_SUCCESS'
export function availableDevicesToFloorPlansSuccess(
    availableDevicesToFloorPlans
) {
    return {
        type: AVAILABLE_DEVICES_TO_FLOOR_PLANS_SUCCESS,
        availableDevicesToFloorPlans
    }
}

export const AVAILABLE_DEVICES_TO_FLOOR_PLANS_ERROR =
    'AVAILABLE_DEVICES_TO_FLOOR_PLANS_ERROR'
export function availableDevicesToFloorPlansError() {
    return {
        type: AVAILABLE_DEVICES_TO_FLOOR_PLANS_ERROR
    }
}

export const FLOOR_PLAN_DEVICES_SUCCESS = 'FLOOR_PLAN_DEVICES_SUCCESS'
export function floorPlanDevicesSuccess(
    floorPlanDevices,
    floorPlanNetworkDevices = null
) {
    return {
        type: FLOOR_PLAN_DEVICES_SUCCESS,
        floorPlanDevices,
        floorPlanNetworkDevices
    }
}

export const UPDATE_DEVICE_OF_FLOOR_PLAN_REQUEST =
    'UPDATE_DEVICE_OF_FLOOR_PLAN_REQUEST'
export function updateDeviceOfFloorPlanRequest(
    isNetworkDevice,
    floorPlanId,
    deviceId,
    locationId,
    body
) {
    return {
        type: UPDATE_DEVICE_OF_FLOOR_PLAN_REQUEST,
        isNetworkDevice,
        floorPlanId,
        deviceId,
        locationId,
        body
    }
}

export const UPDATE_DEVICE_OF_FLOOR_PLAN_SUCCESS =
    'UPDATE_DEVICE_OF_FLOOR_PLAN_SUCCESS'
export function updateDeviceOfFloorPlanSuccess() {
    return {
        type: UPDATE_DEVICE_OF_FLOOR_PLAN_SUCCESS
    }
}

export const UPDATE_DEVICE_OF_FLOOR_PLAN_ERROR =
    'UPDATE_DEVICE_OF_FLOOR_PLAN_ERROR'
export function updateDeviceOfFloorPlanError() {
    return {
        type: UPDATE_DEVICE_OF_FLOOR_PLAN_ERROR
    }
}

export const DELETE_DEVICE_FROM_FLOOR_PLAN_REQUEST =
    'DELETE_DEVICE_FROM_FLOOR_PLAN_REQUEST'
export function deleteDeviceFromFloorPlanRequest(
    isNetworkDevice,
    floorPlanId,
    deviceId,
    locationId
) {
    return {
        type: DELETE_DEVICE_FROM_FLOOR_PLAN_REQUEST,
        isNetworkDevice,
        floorPlanId,
        deviceId,
        locationId
    }
}

export const DELETE_DEVICE_FROM_FLOOR_PLAN_SUCCESS =
    'DELETE_DEVICE_FROM_FLOOR_PLAN_SUCCESS'
export function deleteDeviceFromFloorPlanSuccess() {
    return {
        type: DELETE_DEVICE_FROM_FLOOR_PLAN_SUCCESS
    }
}

export const DELETE_DEVICE_FROM_FLOOR_PLAN_ERROR =
    'DELETE_DEVICE_FROM_FLOOR_PLAN_ERROR'
export function deleteDeviceFromFloorPlanError() {
    return {
        type: DELETE_DEVICE_FROM_FLOOR_PLAN_ERROR
    }
}

export const REFRESH_FLOOR_PLAN_DEVICES = 'REFRESH_FLOOR_PLAN_DEVICES'
export function refreshFloorPlanDevices(locationId) {
    return {
        type: REFRESH_FLOOR_PLAN_DEVICES,
        locationId
    }
}

export const GET_ESCALATION_LEVELS = 'GET_ESCALATION_LEVELS'
export function getEscalationLevels(locationId) {
    return {
        type: GET_ESCALATION_LEVELS,
        locationId
    }
}

export const POST_ESCALATION_LEVELS = 'POST_ESCALATION_LEVELS'
export function postEscalationLevels(escalationLevels, locationId) {
    return {
        type: POST_ESCALATION_LEVELS,
        escalationLevels,
        locationId
    }
}

export const SET_ESCALATION_LEVELS = 'SET_ESCALATION_LEVELS'
export function setEscalationLevels(escalationLevels) {
    return {
        type: SET_ESCALATION_LEVELS,
        escalationLevels
    }
}
